import { useEffect, useRef } from "react"
import Button from "../../../common/Button"
import { useDispatch, useSelector } from "react-redux"
import { documentsActions } from "../../../../store/documents"
import { formatDate } from "../../../../lib/script"
import { rejectOversizedBoxUploadFiles } from "../../../../lib/docs"
import { notificationActions } from "../../../../store/notifications"

const FileUploadButton = ({setUploaded}) => {
    const inputRef = useRef(null)
    const user = useSelector(state => state.user.user)
    const triggerFileUpload = useSelector(state => state.documents.triggerFileUpload)
    const dispatch = useDispatch()
    const onFileDrop = (e) => {
        if (e.target.files.length > 0) {
            const { accepted, rejectedMessage } = rejectOversizedBoxUploadFiles(e.target.files)
            if (rejectedMessage) {
                dispatch(notificationActions.setError({ errorMessage: rejectedMessage }))
            }
            if (accepted.length === 0) {
                e.target.value = ''
                return
            }

            let filesArray = accepted.map(item => {
                
                return {
                    id: `${item.name}-${item.size}-${item.lastModified}-${Date.now()}`,
                    file: item.name,
                    file_to_upload: item,
                    dateuploaded: formatDate(new Date()),
                    uploader: user.name,
                    type: null,
                    notes: 'same as type, no notes!'
                }
            })
            setUploaded(filesArray) 
        }

	}

    const openUploadHandler = () => {
        inputRef.current.click()
    }

    useEffect(() => {
        if (triggerFileUpload) {
            openUploadHandler()
            dispatch(documentsActions.resetTriggerFileUpload())
        }
    }, [triggerFileUpload])

    
    return <>
        <input ref={inputRef} type="file" value="" onChange={onFileDrop} multiple name="upload_number_1" id="upload_number_1" style={{display: 'none'}}/>
        <Button click={openUploadHandler}><i className="ti ti-square-plus" ></i>Upload new document</Button>
    </>
}

export default FileUploadButton